import React from "react";
import { HashLink } from 'react-router-hash-link';
import styled from "styled-components";
import Socials from "./Socials";
import Certs from "./Certs";


const Foot = styled.div`
    background: ${({content}) => content.titleBgColor};
    a { color: ${({content}) => content.titleTextColor};}
    color: ${({content}) => content.titleTextColor};
    display: flex;
    padding: 5px;
    flex-wrap: wrap;
    column-gap: 100px;
    row-gap: 20px;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
`;

export default function Footer({content}) {
      
    const today = new Date();
    const year = today.getFullYear();
    const termsTitle = (content.legal.complaints && content.legal.complaints.length>0) ? 'Terms of Use, Privacy Policy & Complaints' : 'Terms of Use & Privacy Policy';

    return(
        <div>
            <div style={{ padding: '5px', paddingTop: '7px', background: content.styles.titleBgColor}}><hr color={content.styles.highlightColor}></hr></div>
            <Foot content={content.styles}>
                <Socials content={content}/>
                <Certs content={content}/>
                <HashLink to="/legal#Terms" ><small>{termsTitle}</small></HashLink>
                <small>Copyright &copy; {year} {content.businessName}. All Rights Reserved</small>
            </Foot>
        </div>
    )
}

